/* eslint-disable node/no-unsupported-features */
import React, {Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';
import Home from './Home';
import Header from './Header';
import Footer from './Footer';
import TelomereTool from './TelomereTool';
import Privacy from './Privacy';
import Terms from './Terms';
import NotFound from './NotFound';

import '../css/App.css';

const App = () => (
    <Fragment>
        <header>
            <Header/>
        </header>

        <main>
            <Switch>
                <Route exact path="/" component={Home}/>
                <Route exact path="/telomere" component={TelomereTool}/>
                <Route exact path="/privacy" component={Privacy}/>
                <Route exact path="/terms" component={Terms}/>
                <Route component={NotFound}/>
            </Switch>
        </main>

        <footer>
            <Footer/>
        </footer>
    </Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js